<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon src="assets/svg/child.svg"></svg-icon>
            <h1 class="page-title">{{'daycare.detalhecrianca'|translate}}</h1>
            <a class="btn btn-gray-fill" [routerLink]="['/daycare']">{{'voltar'|translate}}</a>
        </div>

        <div *ngIf="child">
            <!-- Cabeçalho: dados da criança -->
            <div class="daycare-card">
                <div class="daycare-card-head">
                    <h4 class="mb-0">{{ child.name }}</h4>
                    <button type="button" class="btn btn-sm btn-gray-fill" *ngIf="canWrite && !editingChild"
                            [disabled]="loading" (click)="openEditChild()">
                        <svg-icon class="mr-1" src="assets/svg/edit.svg"></svg-icon>{{'editar'|translate}}
                    </button>
                </div>

                <div class="daycare-info" *ngIf="!editingChild">
                    <span><b>{{'colaborador'|translate}}:</b> {{ child.employee?.name }}</span>
                    <span><b>{{'re'|translate}}:</b> {{ child.employee?.re }}</span>
                    <span><b>{{'daycare.ano'|translate}}:</b> {{ child.year || '—' }}</span>
                    <span *ngIf="child.employee?.email"><b>E-mail:</b> {{ child.employee?.email }}</span>
                </div>

                <!-- Edição inline da criança -->
                <div class="daycare-form-inline" *ngIf="editingChild">
                    <div class="input-material">
                        <input id="childName" [(ngModel)]="childForm.name" class="form-control" type="text" required/>
                        <label for="childName">{{'crianca'|translate}}</label>
                    </div>
                    <div class="input-material">
                        <input id="childYear" [(ngModel)]="childForm.year" class="form-control" type="number"/>
                        <label for="childYear">{{'daycare.ano'|translate}}</label>
                    </div>
                    <button type="button" class="btn btn-primary text-white" [disabled]="loading" (click)="saveChild()">{{'salvar'|translate}}</button>
                    <button type="button" class="btn btn-secondary text-white" [disabled]="loading" (click)="cancelChild()">{{'cancelar'|translate}}</button>
                </div>
            </div>

            <!-- Guardiões -->
            <div class="daycare-card mt-3">
                <div class="daycare-card-head">
                    <h5 class="mb-0">{{'pessoasautorizadas'|translate}}</h5>
                    <button type="button" class="btn btn-sm btn-secondary text-white" *ngIf="canWrite"
                            [disabled]="loading" (click)="openAddGuardian()">
                        <svg-icon class="mr-1" src="assets/svg/plus-circle.svg"></svg-icon>{{'daycare.adicionarguardiao'|translate}}
                    </button>
                </div>

                <!-- Form inline de guardião (adicionar/editar) -->
                <div class="daycare-form-inline daycare-guardian-form" *ngIf="showGuardianForm">
                    <div class="input-material">
                        <select id="gkind" [(ngModel)]="guardianForm.kind" class="form-control">
                            <option value="authorized">{{'daycare.autorizado'|translate}}</option>
                            <option value="parent">{{'paimae'|translate}}</option>
                        </select>
                        <label for="gkind" class="mb-0 mr-3">{{'daycare.tipo'|translate}}</label>
                    </div>
                    <div class="input-material">
                        <input id="gname" [(ngModel)]="guardianForm.name" class="form-control" type="text" required/>
                        <label for="gname">{{'daycare.nome'|translate}}</label>
                    </div>
                    <div class="input-material">
                        <input id="gdoc" [(ngModel)]="guardianForm.documentRaw" class="form-control" type="text"/>
                        <label for="gdoc">{{'daycare.documento'|translate}}</label>
                    </div>
                    <button type="button" class="btn btn-primary text-white" [disabled]="loading" (click)="saveGuardian()">{{'salvar'|translate}}</button>
                    <button type="button" class="btn btn-secondary text-white" [disabled]="loading" (click)="cancelGuardian()">{{'cancelar'|translate}}</button>
                </div>

                <div class="table-responsive">
                    <table class="table table_regular">
                        <thead>
                        <tr>
                            <th>{{'daycare.tipo'|translate}}</th>
                            <th>{{'daycare.nome'|translate}}</th>
                            <th>{{'daycare.documento'|translate}}</th>
                            <th class="w-10"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngIf="isNullOrUndefined(child.guardians) || child.guardians.length === 0">
                            <td colspan="4"><p class="text-center my-4">{{'daycare.semguardioes'|translate}}</p></td>
                        </tr>
                        <tr *ngFor="let g of child.guardians">
                            <td>
                                <span class="badge badge-primary" *ngIf="isParent(g)">{{'paimae'|translate}}</span>
                                <span class="badge badge-light" *ngIf="!isParent(g)">{{'daycare.autorizado'|translate}}</span>
                            </td>
                            <td>{{ g.name }}</td>
                            <td>
                                <span *ngIf="!guardianHasNoDocument(g)">{{ g.documentRaw }}</span>
                                <span *ngIf="guardianHasNoDocument(g)" class="badge badge-warning daycare-nodoc"
                                      [title]="'daycare.semdocumentotooltip'|translate">
                                    ⚠️ {{'daycare.semdocumento'|translate}}
                                </span>
                            </td>
                            <td class="text-center">
                                <div class="table_action" *ngIf="canWrite">
                                    <svg-icon (click)="openEditGuardian(g)" src="assets/svg/edit.svg"></svg-icon>
                                    <svg-icon (click)="removeGuardian(g)" src="assets/svg/close-red.svg"></svg-icon>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div *ngIf="!child && !loading" class="text-center my-5">{{'daycare.criancanaoencontrada'|translate}}</div>
    </div>
</div>
